import { request } from "$/lib/api"
import {
  AlfredImpactBaseline,
  AlfredImpactResponse,
  Route,
  populateRoute,
} from "@repo/common"
import {
  queryOptions,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query"

async function fetchAlfredImpact(
  storeId: string,
): Promise<AlfredImpactResponse> {
  return await request<AlfredImpactResponse>({
    url: populateRoute(Route.STATS__ALFRED_IMPACT, storeId),
    method: "GET",
  })
}

async function updateAlfredImpactBaseline(
  storeId: string,
  data: AlfredImpactBaseline,
) {
  return await request<void>({
    url: populateRoute(Route.STATS__UPDATE_ALFRED_IMPACT_BASELINE, storeId),
    method: "PUT",
    data,
  })
}

export function useAlfredImpactBaselineMutation(storeId: string) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data: AlfredImpactBaseline) =>
      updateAlfredImpactBaseline(storeId, data),
    onSettled: () =>
      queryClient.invalidateQueries(alfredImpactQueries.detail(storeId)),
  })
}

const alfredImpactQueries = {
  detail: (storeId: string) =>
    queryOptions({
      queryKey: ["alfred-impact", storeId],
      queryFn: () => fetchAlfredImpact(storeId),
    }),
}

export default alfredImpactQueries
